<template>
  <div class="uploading full-size flex-vertical">
    <ModalWindow
      ref="timerNotificationModalWindow"
      name="timerNotificationModalWindow"
      header="Предупреждение"
    >
      <div class="flex-vertical">
        <div class="timer-notification-modal-window-text">
          На загрузку всех документов отводится
          {{ expirationMinutes }} минут<br />
          (Таймер в верхнем правом углу)
        </div>
        <button @click="$refs.timerNotificationModalWindow.showed = false">
          Понятно
        </button>
      </div>
    </ModalWindow>
    <ModalWindow
      ref="invalidDocumentsModalWindow"
      name="invalidDocumentsModalWindow"
      header="Не все документы загружены"
    >
      <div class="flex-vertical" v-if="invalidDocuments.length > 0">
        <div class="invalid-documents-modal-window-text">
          <div v-if="invalidDocuments[0].isMissing">Отсутствует документ:</div>
          <div v-else>
            Загруженный документ не соответствует ожидаемому типу:
          </div>
          <br />
          — {{ invalidDocuments[0].title }}
        </div>
        <div class="invalid-document-buttons">
          <button @click="handleUploadInvalidDocumentClick">Загрузить</button>
          <button
            class="secondary-button"
            v-if="invalidDocuments[0].canSkip"
            @click="handleSkipInvalidDocumentClick"
          >
            Всё равно отправить
          </button>
          <button
            class="secondary-button"
            v-else
            @click="handleCancelSendingClick"
          >
            Отменить
          </button>
        </div>
      </div>
    </ModalWindow>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div class="uploading-header flex">
      <div class="header-menu" @click="menuIsShowed = !menuIsShowed">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="x24 / ic-nav-menu">
            <path
              id="ic-nav-menu"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H4C3.44772 7 3 6.55228 3 6ZM3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12ZM4 17C3.44772 17 3 17.4477 3 18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18C21 17.4477 20.5523 17 20 17H4Z"
              fill="#333333"
            />
          </g>
        </svg>
      </div>
      <img class="header-logo" src="../../../public/icons/logo.svg" />
      <div class="header-empty-div"></div>
      <div v-show="showTimer" class="header-timer font-medium-11px">
        {{ timerMessage }}
      </div>
    </div>
    <div class="uploading-content full-size flex">
      <div v-show="menuIsShowed" class="uploading-documents full-size">
        <div class="documents-header font-regular-13px">
          <img src="../../../public/icons/logo.svg" />
          <div>ЗАГРУЗКА ДОКУМЕНТОВ</div>
        </div>
        <div class="documents-list full-size flex-vertical">
          <div
            v-for="(document, index) in documentsData"
            :key="index"
            @click="selectDocument(index)"
            class="documents-list-item flex"
          >
            <div
              v-if="document.files.length === 0"
              class="document-index font-medium-16px"
            >
              {{ index + 1 }}
            </div>
            <div
              v-else-if="
                (document.type === 'WarTicket' &&
                  isLiableForMilitaryService === false) ||
                document.isValid === true
              "
              class="document-index"
            >
              <img src="../../../public/icons/success-32.svg" />
            </div>
            <div
              v-else-if="document.isValidating"
              class="document-index busy-loader"
            >
              <img src="../../../public/icons/busy-loader.svg" />
            </div>
            <div v-else class="document-index">
              <img src="../../../public/icons/error.svg" />
            </div>
            <div
              class="document-title font-regular-13px"
              :class="{ selected: selectedDocumentIndex === index }"
            >
              {{ document.title }}
            </div>
          </div>
        </div>
        <button @click="sendDocuments">Отправить документы</button>
      </div>
      <div
        v-if="isReadyToSend === false"
        class="uploaded-document full-size flex-vertical"
      >
        <UploadingFormMobile
          :title="currentDocumentData.title"
          :type="currentDocumentData.type"
          :files="currentDocumentData.files"
          ref="uploadingForm"
          @files-uploaded="handleFilesUploaded"
          @pdf-rendered="handlePdfRendered"
          @images-deleted="handleImagesDeleted"
          @uploading-started="startProcessingTimer"
          @select-next-step="selectNextStep"
        >
          <template slot="uploadingcomment" v-if="selectedDocumentIndex === 0">
            <div class="document-uploading-comment font-regular-16px">
              Загрузите 2 разворота:
              <ul class="passport-pages-list">
                <li>основной с фотографией</li>
                <li>актуальная прописка</li>
              </ul>
              Изображения должны быть высокого качества, без бликов. Страницы
              паспорта полностью попадают в кадр и не закрыты пальцами.
            </div>
          </template>

          <template
            slot="uploadingcomment"
            v-if="
              selectedDocumentIndex === 1 &&
              currentDocumentData.files.length === 0
            "
          >
            <div class="document-uploading-comment font-regular-16px">
              Загрузите фотографию или скан только лицевой стороны документа.
            </div>
          </template>

          <template
            slot="uploadingcomment"
            v-if="
              selectedDocumentIndex === 2 &&
              currentDocumentData.files.length === 0
            "
          >
            <div class="document-uploading-comment font-regular-16px">
              Необязательный документ. При наличии – загрузите фотографию или
              скан только лицевой стороны документа.
            </div>
          </template>

          <div
            v-if="selectedDocumentIndex === 3"
            class="military-document-content"
          >
            <div class="document-content-title font-semibold-14px">
              Являетесь ли вы военнообязанным(-ной)?
            </div>
            <div class="document-content-buttons flex-vertical">
              <BaseRadioButton
                v-model="currentDocumentData.isLiableForMilitaryService"
                :value="true"
                label="Являюсь"
              >
              </BaseRadioButton>
              <BaseRadioButton
                v-model="currentDocumentData.isLiableForMilitaryService"
                :value="false"
                label="Не являюсь"
              >
              </BaseRadioButton>
            </div>
          </div>
          <template slot="uploadingcomment" v-if="selectedDocumentIndex === 3">
            <div
              v-if="currentDocumentData.isLiableForMilitaryService"
              class="military-document-uploading-comment font-regular-16px"
            >
              Загрузите сканы военного билета или удостоверения гражданина,
              подлежащего призыву на военную службу, либо сканы документов, их
              заменяющие (временное удостоверение гражданина, справка).
            </div>
            <div
              v-else
              class="military-document-uploading-comment font-regular-16px"
            >
              Загрузите скан страницы №13 паспорта с отметкой о воинской
              обязанности.
            </div>
          </template>

          <div
            v-if="selectedDocumentIndex === 4"
            class="education-document-content"
          >
            <div class="document-content-title font-semibold-14px">
              Уровень образования
            </div>
            <div class="document-content-buttons flex-vertical">
              <BaseRadioButton
                v-model="currentDocumentData.educationLevel"
                :value="0"
                label="Высшее образование (диплом института/университета)"
                @change="patchCurrentDocument"
              >
              </BaseRadioButton>
              <BaseRadioButton
                v-model="currentDocumentData.educationLevel"
                :value="1"
                label="Среднее профессиональное образование (диплом техникума/колледжа)"
                @change="patchCurrentDocument"
              >
              </BaseRadioButton>
              <BaseRadioButton
                v-model="currentDocumentData.educationLevel"
                :value="2"
                label="Начальное профессиональное образование (диплом проф.училища/лицея)"
                @change="patchCurrentDocument"
              >
              </BaseRadioButton>
              <BaseRadioButton
                v-model="currentDocumentData.educationLevel"
                :value="3"
                label="Среднее общее образование (аттестат выпускника 11-го класса)"
                @change="patchCurrentDocument"
              >
              </BaseRadioButton>
              <BaseRadioButton
                v-model="currentDocumentData.educationLevel"
                :value="4"
                label="Основное общее образование (аттестат выпускника 9-го класса)"
                @change="patchCurrentDocument"
              >
              </BaseRadioButton>
            </div>
          </div>
          <template slot="uploadingcomment" v-if="selectedDocumentIndex === 4">
            <div class="document-uploading-comment font-regular-16px">
              Загрузите фотографию или скан только лицевой стороны документа.
            </div>
          </template>
        </UploadingFormMobile>
      </div>
      <div
        v-else-if="!menuIsShowed"
        class="ready-to-send flex-vertical full-size"
      >
        <div clas="ready-to-send-main flex-vertical">
          <div class="ready-to-send-main-title font-bold-32px">
            Документы загружены
          </div>
          <div class="ready-to-send-main-text font-regular-16px">
            Подтвердите отправку документов для начала их обработки
          </div>
        </div>
        <div class="full-height"></div>
        <div class="ready-to-send-buttons flex-vertical">
          <button class="secondary-button" @click="handleBackToDocumentList">
            Вернуться к списку документов
          </button>
          <button @click="sendDocuments">Отправить документы</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadingPageMixin from "../mixins/UploadingPageMixin.js";
import BaseRadioButton from "../common/BaseRadioButton.vue";
import ModalWindow from "../common/ModalWindow.vue";
import UploadingFormMobile from "./UploadingFormMobile.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "UploadingPageMobile",
  components: {
    UploadingFormMobile,
    BaseRadioButton,
    ModalWindow,
    Loading,
  },
  mixins: [UploadingPageMixin],
  data() {
    return {
      menuIsShowed: false,
    };
  },
  methods: {
    selectDocument(index) {
      this.menuIsShowed = false;
      this.selectedDocumentIndex = index;
    },
    handleBackToDocumentList() {
      this.isReadyToSend = false;
      this.menuIsShowed = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../src/styles/colors.scss";

.uploading {
  background-color: $background-color;
  padding: 15px;
}

.uploading-header {
  margin-bottom: 10px;
}

.header-menu {
  cursor: pointer;
}

.header-logo {
  margin-left: 10px;
}

.header-title {
  margin-left: 13px;
  padding-left: 13px;
  border-left: 1px solid #1a1f2399;
  color: #1a1f2399;
}

.header-empty-div {
  flex: 1 0 0;
}

.header-timer {
  letter-spacing: 0.5px;
  color: #1a1f2399;
  border-radius: 4px;
  background-color: #959ba12f;
  padding: 2px 8px;
  align-self: center;
}

.validation-message {
  color: red;
  font-family: IBMPlexSans-regular;
  margin-bottom: 10px;
}

.uploading-documents {
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  flex-direction: column;
  background-color: $white-color;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  padding: 0px 15px 15px 15px;
}

.documents-header {
  padding: 50px 23px 50px 25px;
  margin: 0px -15px;
  background-color: $background-color;
  color: #959ba1;
  margin-bottom: 10px;
  border-bottom: 1px solid #959ba1;
}

.documents-list {
  overflow-y: auto;
  margin-bottom: 5px;
}

.documents-list-item {
  border-bottom: 1px solid #1a1f2399;
  padding: 10px 11px 14px 0px;
  cursor: pointer;
  user-select: none;
}

.documents-list-item:hover {
  background-color: #f8f8f8;
}

.document-index {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 50%;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -2px;
}

.document-title {
  margin-left: 10px;
  margin-top: 5px;
}
.document-title.selected {
  font-family: IBMPlexSans-semibold;
}
.validation-success-icon {
  flex: 0;
}

.document-content-title {
  margin-bottom: 10px;
  align-items: center;
}
.document-content-buttons {
  margin-bottom: 5px;
}

.document-content-buttons > div {
  margin-right: 12px;
  margin-bottom: 5px;
}

.military-document-uploading-comment,
.document-uploading-comment {
  margin-bottom: 5px;
}

.timer-notification-modal-window-text {
  margin-bottom: 84px;
}

.timer-notification-modal-window-buttons {
  align-items: flex-start;

  button {
    margin-right: 8px;
  }
}

.invalid-documents-modal-window-text {
  margin-bottom: 84px;
}
.invalid-document-buttons {
  display: flex;
  align-self: center;
}
.invalid-document-buttons > button {
  margin-right: 12px;
}
.secondary-button {
  background: transparent;
  color: #181818;
  margin-right: 0px !important;
}

.ready-to-send {
  padding: 0px 15px 15px 15px;
}

.ready-to-send-buttons {
  align-self: center;
  .secondary-button {
    border: none;
    margin-bottom: 10px;
  }
}

.ready-to-send-main {
  top: 30%;
  align-items: center;
}

.ready-to-send-main-title {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.ready-to-send-main-text {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

@media screen and (max-width: 500px) {
  .ready-to-send-main {
    top: 20%;
  }

  .ready-to-send-main-title {
    font-size: 20px;
    margin-bottom: 16px;
  }

  .ready-to-send-main-text {
    font-size: 13px;
  }
}

.passport-pages-list {
  list-style-position: inside; 
  margin: 10px 20px;
}

.base-radio-button{
  padding: 6px 12px;
}
</style>